export default "__VITE_ASSET__BRicStze__"